import { useMemo } from "react";
import PayrollExport from "../../components/modal/PayrolExport";
import { useVisible } from "utils/hooks/useVisible";

export const usePayrollExportModal = ({ refetch }: any) => {
    const { visible, open, close } = useVisible();
    
    const modal = useMemo(() => {
        return (
            <PayrollExport
                isOpen={visible}
                close={close}
                refetch={refetch}
            />
        )
    }, [visible, close, refetch]);

    return { modal, open };
}
